import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-column gap-3" };
import { computed, inject } from "vue";
// Composable
import { useConversationResponse } from "../composables/useConversationPolling";
// Components
import Summary from "../components/SummaryBlock.vue";
import Transcript from "../components/TranscriptBlock.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationView',
    props: {
        showSummary: { type: Boolean },
        showSummaryAccordion: { type: Boolean },
        showTranscript: { type: Boolean },
        showTranscriptAccordion: { type: Boolean },
        compact: { type: Boolean },
        excerptable: { type: Boolean },
        response: {},
        studyName: {},
        activityName: {},
        taskName: {},
        taskIndex: {},
        taskCount: {},
        fullName: {},
        firstName: {},
        username: {},
        userId: {},
        responseId: {},
        responseUrl: {},
        guidelinesCustomized: { type: Boolean },
        userHasResponse: { type: Boolean },
        taskConfigUrl: {}
    },
    setup(__props) {
        const props = __props;
        const i18n = inject("i18n");
        // Use composable for reactive response with automatic polling
        const { response: currentResponse, isPolling: summaryRegenerationPending, regenerateSummary } = useConversationResponse(props.response);
        // Computed clipboard header for copy operations
        const clipboardHeader = computed(() => {
            const lines = [];
            if (props.studyName) {
                lines.push(`${i18n.t("Study")}: ${props.studyName}`);
            }
            if (props.activityName) {
                lines.push(`${i18n.t("Activity")}: ${props.activityName}`);
            }
            if (props.taskName) {
                lines.push(`${i18n.t("Task")} ${props.taskIndex}/${props.taskCount}: ${props.taskName}`);
            }
            if (props.fullName || props.username || props.userId) {
                const participant = `${props.fullName || ""} ${props.username ? "@" + props.username : ""} ${props.userId ? "#" + props.userId : ""}`.trim();
                lines.push(`${i18n.t("Participant")}: ${participant}`);
            }
            if (props.responseId) {
                lines.push(`${i18n.t("Response Reference")}: #TR${props.responseId}`);
            }
            if (props.responseUrl) {
                lines.push(props.responseUrl);
            }
            return lines.length > 0 ? lines.join("\n") + "\n\n" : "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.showSummary)
                    ? (_openBlock(), _createBlock(Summary, {
                        key: 0,
                        excerptable: __props.excerptable,
                        response: _unref(currentResponse),
                        "wrap-in-accordion": props.showSummaryAccordion,
                        "clipboard-header": clipboardHeader.value,
                        pending: _unref(summaryRegenerationPending),
                        "guidelines-customized": props.guidelinesCustomized,
                        "user-has-response": props.userHasResponse,
                        "task-config-url": props.taskConfigUrl,
                        onRegenerate: _unref(regenerateSummary)
                    }, null, 8, ["excerptable", "response", "wrap-in-accordion", "clipboard-header", "pending", "guidelines-customized", "user-has-response", "task-config-url", "onRegenerate"]))
                    : _createCommentVNode("", true),
                (props.showTranscript)
                    ? (_openBlock(), _createBlock(Transcript, {
                        key: 1,
                        excerptable: __props.excerptable,
                        response: _unref(currentResponse),
                        "wrap-in-accordion": props.showTranscriptAccordion,
                        "clipboard-header": clipboardHeader.value,
                        "user-name": props.firstName || props.username || 'User'
                    }, null, 8, ["excerptable", "response", "wrap-in-accordion", "clipboard-header", "user-name"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
